module.exports = __webpack_public_path__ + "81f57861ed4ac74741f5671e1dff2fd9.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-BoldItalic.woff
// module id = 343
// module chunks = 0